// Nirvana page-view system — reusable column/view definitions per table page.
// Customization controls DISPLAY only; columns marked `locked` can never be
// hidden (protects mandatory information such as identity and status).
import { Table2, LayoutGrid, Kanban, CalendarDays, Rows3 } from "lucide-react";

export const VIEW_TYPES = [
  { key: "table", label: "Table", icon: Table2 },
  { key: "cards", label: "Cards", icon: LayoutGrid },
  { key: "board", label: "Board", icon: Kanban },
  { key: "calendar", label: "Calendar", icon: CalendarDays },
  { key: "compact", label: "Compact List", icon: Rows3 },
];

export const DENSITIES = [
  { key: "compact", label: "Compact", py: "py-1.5" },
  { key: "comfortable", label: "Comfortable", py: "py-3" },
  { key: "spacious", label: "Spacious", py: "py-5" },
];

export const densityPad = (key) => (DENSITIES.find((d) => d.key === key) || DENSITIES[1]).py;

// Default per-page view state used when a user has no saved preference.
export function defaultPageState(pageDef) {
  return {
    view: pageDef.defaultView || "table",
    density: "comfortable",
    columns: {
      order: pageDef.columns.map((c) => c.key),
      hidden: pageDef.columns.filter((c) => c.defaultHidden).map((c) => c.key),
      widths: {},
    },
    sort: pageDef.defaultSort || { key: pageDef.columns[0].key, dir: "asc" },
    groupBy: pageDef.defaultGroupBy || null,
  };
}

// Resolve the ordered, visible column list from state (locked columns always shown).
export function resolveColumns(pageDef, state) {
  const byKey = Object.fromEntries(pageDef.columns.map((c) => [c.key, c]));
  const order = (state.columns?.order || pageDef.columns.map((c) => c.key)).filter((k) => byKey[k]);
  // include any new columns not yet in saved order
  pageDef.columns.forEach((c) => { if (!order.includes(c.key)) order.push(c.key); });
  const hidden = new Set(state.columns?.hidden || []);
  return order.map((k) => byKey[k]).filter((c) => c && (c.locked || !hidden.has(c.key)));
}
